import React, { useEffect } from "react";
import Chart from "chart.js/auto";
import { Doughnut } from "react-chartjs-2";
import { CategoryScale } from "chart.js";
Chart.register(CategoryScale);

export const PieChart = ({ backgroundColor = [], plotData }) => {
  const safePlotData = Array.isArray(plotData) ? plotData : [];
  const safeBackground = Array.isArray(backgroundColor) ? backgroundColor : [];

  // compute center text safely (avoid reduce on empty array)
  const centerText = safePlotData.length
    ? safePlotData.reduce((a, b) => a + (Number(b) || 0), 0) / safePlotData.length
    : 0;

  const data = {
    datasets: [
      {
        label: "Dataset",
        data: safePlotData,
        weight: 1,
        backgroundColor: safeBackground.length ? safeBackground : ["#E6E6E6"],
        hoverOffset: 4,
      },
    ],
  };

  const options = {
    title: {
      display: true,
      text: "Average Rainfall per month",
      fontSize: 20,
    },
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
      position: "right",
    },
  };

  const plugins = [
    {
      beforeDraw: function (chart) {
        const width = chart.width,
          height = chart.height,
          ctx = chart.ctx;
        ctx.restore();
        const fontSize = (height / 100).toFixed(2);
        // const halfFontSize = (fontSize / 1.5).toFixed(2);
        ctx.font = fontSize + "em Poppins";
        ctx.textBaseline = "top";
        var text = String(Math.round(centerText * 100) / 100),
          textX = Math.round((width - ctx.measureText(text).width) / 2),
          textY = height / 2.1;
        ctx.fillText(text, textX, textY);
        //  ctx.restore();
        //  ctx.font = halfFontSize + "em Poppins";
        //  ctx.fillText("title", textX +2.5, textY + 40);
         ctx.save();
        
      },
    },
  ];
  return <Doughnut data={data} plugins={plugins} options={options} />;
};
